import { eachDayOfInterval, eachMonthOfInterval, format, getDaysInMonth } from 'date-fns';
import { IGraphMilestone } from './interface';

export const getAllDaysInCurrentMonth = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();

  const daysInCurrentMonth = getDaysInMonth(new Date(year, month));

  const allDatesInCurrentMonth = eachDayOfInterval({
    start: new Date(year, month, 1),
    end: new Date(year, month, daysInCurrentMonth),
  });

  return allDatesInCurrentMonth;
};

export const getSixMonthsInterval = () => {
  const date = new Date();
  // offset in milliseconds
  // const timezoneOffset = date.getTimezoneOffset() * 60000;

  const twoMonthsBackTarget = new Date(date.getFullYear(), date.getMonth() - 2, date.getDate());
  const threeMonthsAheadTarget = new Date(date.getFullYear(), date.getMonth() + 3, date.getDate());

  // it includes the current month
  const twoMonthsBackAndTheCurrentMonth = eachMonthOfInterval({
    start: new Date(twoMonthsBackTarget),
    end: new Date(),
  });

  const twoMonthsAhead = eachMonthOfInterval({
    // current year's current month + 1 because we don't want to include
    // the current month which exists in the twoMonthsBackAndTheCurrentMonth variable
    start: new Date(date.getFullYear(), date.getMonth() + 1),
    end: new Date(threeMonthsAheadTarget),
  });

  const sixMonthsPeriod = twoMonthsBackAndTheCurrentMonth.concat(twoMonthsAhead);

  const allTheDatesBetweenStartAndEndOfSixMonthsPeriod = eachDayOfInterval({
    start: new Date(sixMonthsPeriod[0]),
    end: new Date(sixMonthsPeriod[sixMonthsPeriod.length - 1]),
  });

  return allTheDatesBetweenStartAndEndOfSixMonthsPeriod;
};

export const getAllYearDatesInterval = () => {
  const firstDateOfTheYear = new Date(new Date().getFullYear(), 0, 1);
  const lastDateOfTheYear = new Date(new Date().getFullYear(), 11, 31);

  const allTheDatesBetweenStartAndEndOfYearPeriod = eachDayOfInterval({
    start: new Date(firstDateOfTheYear),
    end: new Date(lastDateOfTheYear),
  });

  return allTheDatesBetweenStartAndEndOfYearPeriod;
};

export const convertToObject = (
  data: Array<Date | number | string>,
): Record<string, IGraphMilestone> => {
  const result: Record<string, IGraphMilestone> = {};
  data.forEach((item) => {
    const date = item instanceof Date ? item : new Date(item);
    const dateFormated = format(date, 'yyyy-MM-dd');
    result[dateFormated] = {
      date,
      paidEur: 0,
      unpaidEur: 0,
      paidUsd: 0,
      unpaidUsd: 0,
      paidMilestonesEur: [],
      paidMilestonesUsd: [],
      unpaidMilestonesEur: [],
      unpaidMilestonesUsd: [],
    };
  });

  return result;
};
